import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RefreshEventService {
  // 一般的なリフレッシュイベント
  private refreshSubject = new Subject<void>();
  public refreshEvent$ = this.refreshSubject.asObservable();

  // Behavioralコンポーネント特定のリフレッシュイベント
  private behavioralRefreshSubject = new Subject<void>();
  public behavioralRefreshEvent$ = this.behavioralRefreshSubject.asObservable();

  // 一般的なリフレッシュを発火
  triggerRefresh(): void {
    this.refreshSubject.next();
  }

  // Behavioralコンポーネントのリフレッシュを発火
  triggerBehavioralRefresh(): void {
    // this.behavioralRefreshSubject.next();
  }
}
